
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-rewriter?{\"id\":\"data-v-54431eec\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./form.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./form.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-54431eec\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./form.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/administracao/comunicados/form.vue
// module id = 693
// module chunks = 0